<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_gallery') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/gallery/update/${gallerydata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                  
                  <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="gallerydata.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('heading') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="textarea"
                                   v-model="gallerydata.heading"
                                   :required="false"
                                   :rows="5"
                                   :max-length="200"
                                   :placeholder="$t('heading')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="number_input" class="col-sm-2 mb-sm-0">
                            {{ $t('order_on') }}
                        </label>
                        <app-input class="col-sm-8" type="number"
                               v-model="gallerydata.order_on"
                               :placeholder="$t('order_on')"/>
                    </div> 
                   
                    <div class="form-group row mb-0" v-if="gallerydata.images">
                        <label class="col-sm-2">
                            {{ $t('gallery_images') }}
                        </label>
                        <div class="col-sm-8">
                          <div class="gallery-wrapper">
                            <app-overlay-loader v-if="preloader"/>
                            <div  v-else v-for="(gallery, index) in gallerydata.images"
                                  :key="'social-link'+index" class="d-flex justify-content-start align-items-center flex-wrap">
                                <app-avatar :title="gallerydata.name" class="mr-2" avatar-class="avatars-w-100" :img="gallery.image"
                                :alt-text="gallerydata.name"/>
                            <div>
                                  <a href="javascript:void(0)" @click="removeImage(gallery, index)"
                                     class="d-flex align-items-center text-muted font-size-90">
                                      <app-icon name="trash" class="mr-1" width="19"/>
                                      {{$t('remove')}}
                                  </a>
                              </div>
                            </div>        
                        </div>
                      </div>
                    </div>

                     <div class="form-group row mb-0">
                        <label class="col-sm-2">
                            {{ $t('upload_images') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="dropzone"
                                       v-model="images"/>
                            <small class="text-muted font-italic">
                                    {{ $t('gallery_size') }}
                                </small>           
                        </div>

                    </div>


                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="gallerydata.status"
                                       :required="true"/>
                    </div>
                  <div class="mt-5 action-buttons">
                      <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                          {{ $t('submit')}}
                      </button>
                      <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                          {{ $t('clear') }}
                      </button>
                  </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateSlider",
        mixins: [FormMixin],
        props: ['gallerydata'],
        data(){
          return { 
            preloader: false, 
            images:[],           
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            removeImage(gallery, index) {
                this.preloader = true;
                const url = actions.DELETE_IMAGE + gallery.id;
                this.axiosPost({
                    url
                }).then(response => {
                    console.log(response.data.message);
                    this.$toastr.s(response.data.message);
                    window.location.reload();
                }).catch(({error}) => {

                    //trigger after error
                }).finally(() => {
                    this.preloader = false;
                });
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.gallerydata)) {
                    
                    if (value != null) formData.append(key, value);
                }
                if (this.images.length) {
                    this.images.forEach(image => formData.append(`images[]`, image));
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>